module.exports = __webpack_public_path__ + "assets/img/teacher (24).bf6bde00.png";